//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Alert,
  AlertIcon,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import { isValidObject } from "../utils/functions";
import ExpandingTextArea from "./form-elements/ExpandingTextArea";
import ReactDatePicker from "./ui-elements/DatePicker";

type Props = {
  onClick: (value: any) => void;
  isSubmitting: boolean;
  clientName: string;
  [key: string]: any;
};

const SubmitFeedback = ({
  onClick = () => {},
  isSubmitting,
  clientName,
  ...rest
}: Props) => {
  const today = new Date().toISOString();
  const todayDate = today.split("T")[0];
  const [callFeedback, setCallFeedback] = React.useState({
    callSummary: "",
    startDate: todayDate,
  });
  const [hasStartDate, setHasStartDate] = React.useState(null);
  const [error, setError] = React.useState(false);

  const handleChange = (key, value) => {
    if (key === "startDate") {
      const formattedValue = value.toISOString().split("T")[0];
      const newValue = { ...callFeedback, [key]: formattedValue };
      setCallFeedback(newValue);
    } else {
      const newValue = { ...callFeedback, [key]: value };
      setCallFeedback(newValue);
    }
  };

  const handleClick = () => {
    if (hasStartDate === "yes") {
      if (isValidObject(callFeedback)) {
        setError(false);
        onClick(callFeedback);
      } else setError(true);
    }
    if (hasStartDate === "no") {
      if (callFeedback.callSummary) {
        setError(false);
        onClick(callFeedback);
      } else setError(true);
    }
    if (!hasStartDate) setError(true);
  };

  return (
    <Flex
      height="100%"
      direction="column"
      justifyContent="space-between"
      {...rest}
    >
      <Stack spacing={[5, 6]}>
        <Alert status="warning" variant="left-accent" lineHeight="short">
          <AlertIcon /> Fill this form only after speaking with {clientName}
        </Alert>

        <FormControl isInvalid={error && !callFeedback.callSummary}>
          <FormLabel mb={1}>Please give a brief call summary</FormLabel>
          <ExpandingTextArea
            isInvalid={error && !callFeedback.callSummary}
            onChange={(summary) => handleChange("callSummary", summary)}
            placeholder={`How did it go? Describe the main points from your interaction with ${clientName}. Include anything you think we should know.`}
            characterLimit={400}
            parseInput={false}
            rows={5}
          />
          <FormErrorMessage>Enter a brief call summary</FormErrorMessage>
        </FormControl>

        <FormControl isInvalid={error && !hasStartDate}>
          <FormLabel mb={1}>Did you conclude on a start date?</FormLabel>
          <RadioGroup
            onChange={(value) => setHasStartDate(value)}
            // isInline
            size="lg"
          >
            <Stack spacing={6}>
              <Radio value="yes" isInvalid={error && !hasStartDate}>
                <Text fontSize="md">Yes</Text>
              </Radio>
              <Radio value="no" isInvalid={error && !hasStartDate}>
                <Text fontSize="md">No</Text>
              </Radio>
            </Stack>
          </RadioGroup>
          <FormErrorMessage>Select one above</FormErrorMessage>
        </FormControl>

        {hasStartDate === "yes" && (
          <FormControl isInvalid={error && !callFeedback.startDate}>
            <FormLabel mb={1}>Please select start date</FormLabel>
            <ReactDatePicker
              onChange={(date) => handleChange("startDate", date)}
              minDate={new Date(todayDate)}
              selected={new Date(callFeedback.startDate)}
              placeholder="Select start date"
            />
            <FormErrorMessage>Select a start date</FormErrorMessage>
          </FormControl>
        )}
      </Stack>

      <Button
        my={[6, 8]}
        size="lg"
        loadingText="Submitting"
        isFullWidth
        onClick={handleClick}
        colorScheme="blue"
        isLoading={isSubmitting}
      >
        Submit feedback
      </Button>
    </Flex>
  );
};

export default SubmitFeedback;
